/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2019, Zumper
 * @description similarListings selectors
 */

import type { NRState } from '@zcode/state-type'
import { compose } from 'redux'
import uniqueListables from '../../../../shared/utils/uniqueListables'

const selectSimilarListings = (state: NRState) => state.similarListings

const selectMeta = compose((state) => state?.meta, selectSimilarListings)

export const selectSimilarListables = compose(
  (state) => uniqueListables(state.listables),
  selectSimilarListings
)

export const selectCurrentKey = compose((state) => state?.currentKey, selectMeta)

export const selectFetchingKey = compose((state) => state?.fetchingKey, selectMeta)

export const selectFetchingPromise = compose((state) => state?.fetchingPromise, selectMeta)

export const selectGroupId = compose((state) => state.groupId, selectMeta)

export const selectSource = compose((state) => state.source, selectMeta)
